import { ROUTE } from "../../../routes";
export const goBack = async (action, _datastore, { goBack }) => {
    await goBack();
};
export const continueAction = async (action, _datastore, { navigateWithClear }) => {
    await navigateWithClear(ROUTE.DASHBOARD);
};
